import React from "react";
import {Box } from '@material-ui/core';

import "./header-bar.css";

export const HeaderBarContainer = (props) => {
    return (<Box boxShadow={3} component="div" className="header-bar">{props.children}</Box>);
}